export const currencyPairToSlug = (pair: string): string =>
  `${pair.slice(0, 3).toLowerCase()}-${pair.slice(3).toLowerCase()}`

const getUrlParts = (): string[] => window.location.pathname.split('/').filter(Boolean)

export const getCurrentSlug = (): string => {
  const urlParts = getUrlParts()
  return urlParts[urlParts.length - 1] ?? ''
}

export const buildCurrencyPairUrl = (slug: string): string => {
  const urlParts = getUrlParts()
  return `${window.location.origin}/${urlParts.slice(0, -1).join('/')}/${slug}/`
}
